import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { useConfigurationAttributeGroupTranslators } from "@plansoft-configuration-renderer/localization";
export function AttributeGroupTitle(props) {
    const { title, titleVariant } = props;
    const translateGroup = useConfigurationAttributeGroupTranslators();
    const groupName = translateGroup.name(title);
    return _jsx(Typography, { variant: titleVariant, children: groupName });
}
//# sourceMappingURL=AttributeGroupTitle.js.map